import { Get } from '../helpers';

const GetSessionRtmp = ({
  sessionUuid,
  language,
}: {
  sessionUuid: string;
  language: string;
}): Promise<{ rtmps_address: string; stream_key: string; expire_at: number }> => {
  return Get({
    path: `/v3/admin/events/session/rtmp/${sessionUuid}/${language}`,
  });
};

export default GetSessionRtmp;
